export const STATUS_FILTER = "status_filter";
export const SELLER_FILTER = "seller_filter";
export const USER_FILTER = "user_filter";
export const EXCLUDE_NCL = "exclude_ncl";
export const EXCLUDE_RCCL = "exclude_rccl";
export const DATES = "dates";
